<template>
    <div class="id_note_date">
        <div class="id_note_date_content">
            <div class="Item_id" style="display:block; text-align: left;" @click="openNotes">
                <span >Id #{{ eventData.id }}</span>
                <div class="btnNotes showTootlip" style="cursor: pointer;">
                    <span class="note_number">
                        <span class="note_number_count">{{ note_number }}</span>
                        <i :class="['fas fa-comment-alt', Number(note_number) > 0 ? 'active' : '']" ></i>
                    </span>
                    <span class="addNotes" style="font-size: 10px;">(Note)</span>
                    <span class="tooltip">Add Note</span>
                </div>
            </div>
            <div class="diffdays">
                <span :class="['nrodiff', eventStatusCss]">{{event_date}}</span>
                <span class="labeldiff">{{ event_date_hours }}</span>
                <!-- <span class="labeldiff">Completed</span> -->
            </div>
        </div>
        <div :class="['eventStatus', eventStatusCss]">{{ eventStatus }}</div>
    </div>
</template>
<script>
export default {
    name: "idStartDate",
    props: {
        eventData: {
            type: Object,
            required: true
        },
        note_number: {
            type: [Number, String],
            required: true
        },
        startDate: {
            type: [String, Date],
            required: true,
            default: 'Sep 30, 2025'
        },
    },
    data(){
        return {
            event_date: null,
            event_date_hours: null,
        };
    },
    created(){
        let date = new Date(this.startDate);
        this.event_date = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "short", // "Sep"
            day: "2-digit", // "03"
            }).format(date);
        this.event_date_hours = new Intl.DateTimeFormat("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true // formato AM/PM
            }).format(date);
    },
    methods: {
        openNotes(){
            this.$emit('open-notes', this.eventData.id);
        }
    },
    computed: {
        eventStatus : function() {
            let str = this.eventData?.status ?? null;
            if (str === null || str === undefined || str.length === 0) {
                return ""; // Handle empty or invalid strings gracefully
            }
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        eventStatusCss : function() {
            let str = this.eventData?.status ?? null;
            return str;
        }
    }
}
</script>
<style scoped lang="scss">
.id_note_date{
    display: flex;
    flex-direction: column;
}
.id_note_date_content{
    display: flex; align-items: flex-start;
}
.item_id {
    font-size: 15px;
    font-weight: 400;
    letter-spacing: -1px;
    line-height: 1;
    padding: 0.2rem 0.5rem;
    height: auto;
}
.diffdays {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    line-height: 1;
    margin: 0px auto 2px auto;
}
span.nrodiff {
    font-size: 14px;
    font-weight: 900;
    letter-spacing: -1px;
}
span.labeldiff {
    font-size: 12px;
    font-weight: 100;
    text-transform: capitalize;
    white-space: break-spaces;
    margin-top: 7px;
}
.btnNotes {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;
}
.btnNotes .note_number {
    position: relative;
}
.btnNotes .note_number .note_number_count{
    margin-right: 3px;
}
.btnNotes .fa-comment-alt.active {
    color: #ffc107;
}
.eventStatus {
    &.pending {background:#0ea1ce; color:#fff;}
    &.connected {background:#318a0e; color:#fff;}
    &.standby {background:#e56d06; color:#fff;}
    &.completed {background:#000080; color:#fff;}
    &.void {
        background-color: #bd0000;
    }
}
span.nrodiff.finished{
    text-decoration: line-through;
    text-decoration-color: rgb(255 22 22 / 50%);
    text-decoration-style: solid;
    text-decoration-thickness: 2px;
    color: #afa9a9;
}
</style>
